import { Footer } from 'components/Footer'
import { Header } from 'components/Header'
import { Layout } from 'components/Layout'
import { Difference } from './components/Difference'
import { Hero } from './components/Hero'
import { HowItWorks } from './components/HowItWorks'
import { Shipping } from './components/Shipping'
import { Signup } from './components/Signup'
import { Subscription } from './components/Subscription'
import { RawFoodSubscriptionRoot } from './RawFoodSubscription.styles'

export const RawFoodSubscription = () => {
  const header = <Header />

  return (
    <Layout header={header}>
      <RawFoodSubscriptionRoot>
        <Hero />
        <HowItWorks />
        <Shipping />
        <Subscription />
        <Difference />
        <Signup />
        <Footer />
      </RawFoodSubscriptionRoot>
    </Layout>
  )
}
